import mixin from './handboek.inkwala.nl';

export default mixin;
